import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import CountUp from "react-countup";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

function ResultsSection() {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });

  const results = [
    { number: 25, label: "Projetos Concluídos", suffix: "+" },
    { number: 30, label: "Problemas Resolvidos", suffix: "K+" },
    { number: 3, label: "Anos de Experiência", suffix: "+" },
    { number: 8, label: "Grandes Operações", suffix: "+" },
    { number: 100, label: "Satisfação Técnica", suffix: "%" },
  ];

  return (
    <section ref={ref} className="results-section-elite position-relative py-20 text-center">
      <Container className="position-relative" style={{ zIndex: 2 }}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h6 className="text-gold text-uppercase fw-bold mb-3 ls-3">Métricas de Impacto</h6>
          <h2 className="section-title-premium mb-4">Resultados <span className="highlight-gold">Reais</span></h2>
          <p className="section-subtitle-premium mx-auto max-w-700 text-gray-soft mb-10">
            Em apenas 3 anos de engenharia dedicada, a <strong>Henrimack</strong> otimizou
            fluxos críticos de empresas que operam no topo de seus segmentos.
          </p>
        </motion.div>

        <Row className="justify-content-center g-4 mb-10">
          {results.map((item, index) => (
            <Col xs={6} md={4} lg={2} key={index}>
              <motion.div
                className="result-card-elite"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
              >
                <h3 className="result-number-elite">
                  {inView && <CountUp end={item.number} duration={2.5} />}
                  {item.suffix || ""}
                </h3>
                <p className="result-label-elite">{item.label}</p>
                <div className="card-glow-accent"></div>
              </motion.div>
            </Col>
          ))}
        </Row>

        <motion.blockquote
          className="testimonial-quote-elite mb-10"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
        >
          “A Henrimack transformou nossa operação digital. Hoje somos 3x mais produtivos.”
        </motion.blockquote>

        <Button href="/#contact" className="btn-gold-elite px-5 py-3">
          Inicie sua Transformação de Elite
        </Button>
      </Container>

      <style>{`
        .results-section-elite {
            background: transparent;
            color: #fff;
            overflow: hidden;
        }

        .ls-3 { letter-spacing: 3px; font-size: 0.75rem; }
        .text-gray-soft { color: #b0b0b0; }
        .max-w-700 { max-width: 700px; }

        .result-card-elite {
            background: rgba(255,255,255,0.02);
            border: 1px solid rgba(255,255,255,0.05);
            border-radius: 24px;
            padding: 2.5rem 1rem;
            position: relative;
            overflow: hidden;
            transition: all 0.4s ease;
        }

        .result-card-elite:hover {
            background: rgba(228, 168, 122, 0.05);
            border-color: var(--elite-gold);
            transform: translateY(-8px);
        }

        .result-number-elite {
            font-size: 2.5rem;
            font-weight: 900;
            color: var(--elite-gold);
            margin-bottom: 0.5rem;
        }

        .result-label-elite {
            font-size: 0.75rem;
            text-transform: uppercase;
            letter-spacing: 1px;
            color: #666;
            font-weight: 700;
        }

        .testimonial-quote-elite {
            font-family: 'Cinzel', serif;
            font-size: 1.5rem;
            color: #b0b0b0;
            font-style: italic;
            max-width: 800px;
            margin: 0 auto;
            opacity: 0.6;
        }

        .card-glow-accent {
            position: absolute; top: 0; left: 0; width: 100%; height: 100%;
            background: radial-gradient(circle at center, rgba(228, 168, 122, 0.05), transparent 70%);
            z-index: -1;
        }

        .btn-gold-elite {
           background: var(--elite-gold);
           color: #000 !important;
           border: none;
           font-weight: 800;
           text-transform: uppercase;
           letter-spacing: 2px;
           border-radius: 12px;
           transition: all 0.4s ease;
           box-shadow: 0 15px 40px rgba(228, 168, 122, 0.3);
        }

        .btn-gold-elite:hover {
           background: #fff;
           transform: translateY(-5px);
           box-shadow: 0 25px 60px rgba(228, 168, 122, 0.5);
        }

        @media (max-width: 768px) {
           .result-number-elite { font-size: 2rem; }
           .testimonial-quote-elite { font-size: 1.1rem; }
        }
      `}</style>
    </section>
  );
}

export default ResultsSection;
